import { useHistory } from "react-router-dom";
import { Bounce, toast } from "react-toastify";

export const useEditorNavigationToasts = ({ t, setLoadingModules }) => {
  const history = useHistory();

  const NavigateToLandingPage = (errorMessage) => {
    toast.error(<div className="notificationText">{t(errorMessage)}</div>, {
      hideProgressBar: false,
      position: "top-right",
      autoClose: 800,
      transition: Bounce,
    });
    setTimeout(() => {
      history.push("/");
      setLoadingModules(false);
    }, 900);
  };

  return { NavigateToLandingPage };
};
